import * as React from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Theme, makeStyles, useTheme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import { LoginGrid } from './LoginGrid';
import { VseAlertContainer } from '../alert/VseAlertContainer';
import * as VseAlert from '../../features/alert';
import * as VseSession from '../../features/session';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  alert: {
    padding: theme.spacing(1),
    margin: theme.spacing(1),
  },
  paper: {
    margin: 'auto',
    padding: theme.spacing(2),
  },
}));

export function LoginPage() {
  const theme = useTheme();
  const classes = useStyles(theme);
  const dispatch = useDispatch();
  const location = useLocation();
  const sessionState = VseSession.useVseSessionState();

  React.useEffect(function handleLoading() {
    return function cleanup() {
      dispatch(VseAlert.dismissValidationProblem());
    };
  }, [dispatch]);

  if (sessionState.token.isAuthenticated) {
    const params = new URLSearchParams(location.search);
    const url = params.get("redirect");
    if (url) {
      return <Redirect to={url} />;
    } else {
      return <Redirect to='/home' />;
    }
  }

  return (
    <main className={classes.root}>
      <VseAlertContainer className={classes.alert} />
      <Paper className={classes.paper}>
        <LoginGrid onSubmit={
          (userName, password) => dispatch(VseSession.login({ userName, password }))
        } />
      </Paper>
    </main>
  );
}
